import { ReactNode } from 'react'

/**
 * Минорный компонент, который показывает всплывающую плашку (alert, toast)
 * об успешной или неудачной операции. Например, при копировании.
 */
export const Alert = ({
  isOpen,
  content = 'Успешно',
  status = 'success',
  className = '',
}: {
  isOpen: boolean
  content: ReactNode
  status: 'success' | 'danger'
  className?: string
}) => {
  return (
    <div
      style={{
        top: '10vh',
        left: '50%',
        zIndex: 10000,
        transform: 'translate(-50%, -50%)',
        display: isOpen ? 'block' : 'none',
      }}
      className={`alert alert-${status} position-fixed min-w-200px w-300px ${className}`}
    >
      {content}
    </div>
  )
}
